"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newEntity = exports.BaseTimestampedEntity = exports.UpdatedAt = exports.CreatedAt = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("./date");
exports.NAMESPACE = 'Entity';
exports.CreatedAt = date_1.DateFromUtcIsoDateString.annotations({
    identifier: `${exports.NAMESPACE}.CreatedAt`,
    title: 'Created At',
    description: 'The date and time when the entity was created',
});
exports.UpdatedAt = date_1.DateFromUtcIsoDateString.annotations({
    identifier: `${exports.NAMESPACE}.UpdatedAt`,
    title: 'Updated At',
    description: 'The date and time when the entity was last updated',
});
exports.BaseTimestampedEntity = effect_1.Schema.Struct({
    createdAt: exports.CreatedAt,
    updatedAt: exports.UpdatedAt,
}).annotations({
    identifier: `${exports.NAMESPACE}.BaseTimestampedEntity`,
    description: 'A base entity with creation and update timestamps',
});
const newEntity = (schema) => schema.pipe(effect_1.Schema.omit('createdAt', 'updatedAt'));
exports.newEntity = newEntity;
//# sourceMappingURL=entity.js.map